"use strict";


/**
 * @type Controller
 * @name CreateCardInfo_Ctrl
 * @packageName createCardInfo_dialog_ctrl.js
 *
 */
class CreateCardInfo_Ctrl {


    constructor($scope, $mdDialog, $http) {

        $scope.$http = $http;
        this.$mdDialog = $mdDialog;

        //Close dialog
        $scope.hideDialog = () => {
            this.cancelButton();
        };

        $scope.confirmButton = () => {
            this.confirmButton();
        };

        $scope.addressCity = $scope.organisationctrl.data.city;
        $scope.addressCountry = $scope.organisationctrl.data.country;
        $scope.addressZip = $scope.organisationctrl.data.zipcode;
        $scope.addressLine1 = $scope.organisationctrl.address_fields[0].address;

        $scope.handleStripe = function (status, response) {
            setTimeout(function(){
                angular.element('.ok').prop('disabled', true);
            },150);
            if (response.error) {

            } else {
                if($scope.createCustomer){
                    this.$http.post("/billing/customer/create", {'token': response.id, email: $scope.user_email}).then((response) => {
                        $scope.confirmButton();
                        angular.element('.ok').prop('disabled', true);
                    });
                }else{
                    this.$http.post("/billing/card/create", {'token': response.id}).then((response) => {
                        $scope.confirmButton();
                        angular.element('.ok').prop('disabled', true);
                    });
                }

            }
        };
    }

    cancelButton() {
        this.$mdDialog.cancel();
    }
    confirmButton() {
        this.$mdDialog.hide();
    }
}


/*
 * Inject dependicies
 */
CreateCardInfo_Ctrl.$inject = ['$scope', '$mdDialog', '$http'];


/*
 * Browsify connection: execute controller
 */
module.exports = CreateCardInfo_Ctrl;
